import { ref, readonly } from 'vue'
import { defineStore } from 'pinia'
import { isProdLikeTenantHost, resolveTenantSlug } from '@/lib/tenant'

/**
 * Tenant context derived from hostname (or local dev override).
 *
 * slug === Firestore schoolId === JWT custom claim for this school's users.
 */
export const useTenantStore = defineStore('tenant', () => {
  const slug = ref<string | null>(resolveTenantSlug())
  const prodLikeHost = ref(isProdLikeTenantHost())

  function refreshFromLocation(): void {
    slug.value = resolveTenantSlug()
    prodLikeHost.value = isProdLikeTenantHost()
  }

  return {
    slug: readonly(slug),
    prodLikeHost: readonly(prodLikeHost),
    refreshFromLocation,
  }
})
